import {
  CREATE_MAIL_CATEGORIA,
  UPDATE_MAIL_CATEGORIA,
  DELETE_MAIL_CATEGORIA,
  CREATE_MAIL_CONTACTOS_LISTA,
  DELETE_MAIL_CONTACTOS_LISTA,
  DELETE_TEMPLATE,
} from "@/apollo/mutations/mail";
import { GET_GERENCIAS, GET_CARGOS, GET_SUCURSALES, GET_WORK_SHIFTS, GET_SINDICATO } from "@/apollo/queries";
import {
  GET_CATEGORIAS_MAIL,
  GET_TEMPLATES_BY_CATEGORIA,
  GET_PAGINACION_CONTACTOS_LISTA,
  GET_LIST_CONTACTOS_USUARIOS,
  LIST_CONTACTOS_BY_EMAIL,
  LIST_LISTAS_CONTACTOS,
  GET_LIST_CORREOS_AUTOMATIZADOS,
} from "@/apollo/queries/mail";

import Vue from "vue";

import { exMut, exQue, MUTACION_CON_CACHE } from "@/utils/gql";
import { mapCorreoToForm } from "./create";

// "las gerencias", "los cargos"… con el término de la empresa
// (utils/terminos.js), para los mensajes de error de abajo
const losPlural = (rootGetters, clave) => {
  const termino = rootGetters["terminos/termino"](clave);
  return `${termino.los} ${termino.plural}`;
};

/**
 * Toast de error desde el store, que no tiene acceso a los helpers del mixin global.
 * Mismo canal que usa `utils/gql.js`.
 */
const toastError = (message) => {
  Vue.$toast.open({
    message,
    type: "error",
    duration: 5000,
    position: "top-right",
  });
};

export const mapTemplatesToForm = (templates = []) => {
  const safeTemplates = Array.isArray(templates) ? templates : [];
  return safeTemplates.map((tpl) => {
    try {
      return { ...tpl, form: mapCorreoToForm(tpl) || {} };
    } catch (error) {
      console.error("Error mapeando template a form:", error);
      return { ...tpl, form: {} };
    }
  });
};

export const recursosState = {
  categoria: {
    id_categoria: null,
    nombre_categoria: "",
    color: "#000000",
  },
  categorias: [],
  categoriasTemplates: {},
  loadingTemplates: false,
  contactLists: [],
  contactPagination: [],
  contactFilters: {
    limite: 15,
    idGerencia: null,
    nombre: "",
  },
  // Slot independiente para el modal de creación de lista
  contactListsModal: [],
  contactPaginationModal: [],
  contactFiltersModal: {
    limite: 15,
    idGerencias: [],
    idCargos: [],
    idSucursales: [],
    nombre: "",
  },
  destinatariosListas: [],
  contacts: [],
  gerencias: [],
  cargos: [],
  sucursales: [],
  turnos: [],
  sindicatos: [],
  correosAutomatizados: [],
};
export const recursosMutations = {
  setCategoria(state, categoria) {
    state.categoria = categoria;
  },
  setCategorias(state, categorias) {
    state.categorias = [
      { value: 0, text: "Todas" },
      ...categorias.map((cat) => ({
        ...cat,
        text: cat.nombre_categoria,
        value: cat.id_categoria,
      })),
    ];
  },
  setCategoriasTemplates(state, categoriasTemplates) {
    state.categoriasTemplates = categoriasTemplates;
  },
  setLoadingTemplates(state, loading) {
    state.loadingTemplates = !!loading;
  },
  removeTemplateFromCategory(state, { idTemplate, idCategoria }) {
    if (!idCategoria || !idTemplate) return;
    const list = state.categoriasTemplates[idCategoria];
    if (!Array.isArray(list)) return;
    state.categoriasTemplates = {
      ...state.categoriasTemplates,
      [idCategoria]: list.filter(
        (tpl) => Number(tpl.id_template) !== Number(idTemplate)
      ),
    };
  },
  replaceCategorias(state, categoria) {
    const indexCat = state.categorias.findIndex(
      (cat) => cat.id_categoria === categoria.id_categoria
    );
    if (indexCat !== -1) {
      state.categorias.splice(indexCat, 1, {
        ...categoria,
        text: categoria.nombre_categoria,
        value: categoria.id_categoria,
      });
    }
  },
  setContactLists(state, lists) {
    state.contactLists = lists;
  },
  setContactListsModal(state, lists) {
    state.contactListsModal = lists;
  },
  setContactPagination(state, pagination) {
    state.contactPagination = pagination;
  },
  setContactPaginationModal(state, pagination) {
    state.contactPaginationModal = pagination;
  },
  setContactFilters(state, filters) {
    state.contactFilters = { ...state.contactFilters, ...filters };
  },
  setContactFiltersModal(state, filters) {
    state.contactFiltersModal = { ...state.contactFiltersModal, ...filters };
  },
  setContacts(state, contacts) {
    state.contacts = contacts;
  },
  setGerencias(state, gerencias) {
    state.gerencias = gerencias;
  },
  setCargos(state, cargos) {
    state.cargos = cargos;
  },
  setSucursales(state, sucursales) {
    state.sucursales = sucursales;
  },
  setTurnos(state, turnos) {
    state.turnos = turnos;
  },
  setSindicatos(state, sindicatos) {
    state.sindicatos = sindicatos;
  },

  setDestinatariosListas(state, listas) {
    const sortedListas = listas.sort((a, b) =>
      a.nombre_lista.localeCompare(b.nombre_lista)
    );
    const reducedListas = sortedListas.reduce((acc, lista) => {
      const firstChar = lista.nombre_lista.charAt(0).toUpperCase();
      if (!acc[firstChar]) {
        acc[firstChar] = [];
      }
      // Preservar destinatarios completos para permitir expansión
      acc[firstChar].push({
        ...lista,
        destinatarios: lista.destinatarios || [],
      });
      return acc;
    }, {});
    state.destinatariosListas = reducedListas;
  },
  setCorreosAutomatizados(state, items) {
    state.correosAutomatizados = Array.isArray(items) ? items : [];
  },
  removeCorreoAutomatizado(state, idTemplate) {
    state.correosAutomatizados = state.correosAutomatizados.filter(
      (item) => Number(item.id_template) !== Number(idTemplate)
    );
  },
};

export const recursosActions = {
  async getCategorias({ commit }) {
    // No se vacía `categoriasTemplates` al empezar: dejarlo en {} hacía que la grilla
    // mostrara "No hay templates" durante toda la carga, y que parpadeara a vacío
    // después de cada borrado o edición de categoría. La lista vieja se mantiene
    // visible bajo el spinner hasta que llega la nueva.
    commit("setLoadingTemplates", true);
    try {
      const categorias = await exQue(
        GET_CATEGORIAS_MAIL,
        { optionAll: false },
        false,
        "",
        "No fue posible cargar las categorías."
      );
      const safeCategorias = categorias || [];
      commit("setCategorias", safeCategorias);

      // Promise.allSettled evita que el fallo de una categoría cancele las demás
      const results = await Promise.allSettled(
        safeCategorias.map((cat) =>
          exQue(GET_TEMPLATES_BY_CATEGORIA, {
            idCategoria: cat.id_categoria,
          }).then((tpls) => mapTemplatesToForm(tpls))
        )
      );

      const categoriasTemplates = safeCategorias.reduce((acc, cat, index) => {
        const result = results[index];
        acc[cat.id_categoria] =
          result.status === "fulfilled" ? result.value || [] : [];
        if (result.status === "rejected") {
          console.error(
            `Error obteniendo templates para categoría ${cat.id_categoria}:`,
            result.reason
          );
        }
        return acc;
      }, {});

      commit("setCategoriasTemplates", categoriasTemplates);

      // Un solo toast para las N categorías: una por fallo sería una lluvia de avisos.
      const fallidas = results.filter((r) => r.status === "rejected").length;
      if (fallidas) {
        toastError(
          fallidas === 1
            ? "No fue posible cargar los templates de una categoría."
            : `No fue posible cargar los templates de ${fallidas} categorías.`
        );
      }
    } catch (error) {
      console.error("Error obteniendo categorías:", error);
      commit("setCategorias", []);
      commit("setCategoriasTemplates", {});
    } finally {
      commit("setLoadingTemplates", false);
    }
  },
  /**
   * Obtiene las listas de contacto disponibles para la empresa.
   * @returns {Promise<Array>} Listado de listas de contacto
   */
  async getContactLists({ state, commit, dispatch }, payload = {}) {
    try {
      const tipo = payload.tipo || "main"; // 'main' (tabla) | 'modal' (crear lista)
      const baseFilters =
        tipo === "modal" ? state.contactFiltersModal : state.contactFilters;

      const filters = {
        limite: payload.limite || baseFilters.limite,
        idGerencia:
          payload.idGerencia !== undefined
            ? Number(payload.idGerencia)
            : baseFilters.idGerencia,
        nombre:
          payload.nombre !== undefined ? payload.nombre : baseFilters.nombre,
      };

      if (tipo === "modal") {
        commit("setContactFiltersModal", filters);
        commit("setContactPaginationModal", []);
        commit("setContactListsModal", []);
      } else {
        commit("setContactFilters", filters);
        commit("setContactPagination", []);
        commit("setContactLists", []);
      }

      const pagination = await exQue(
        GET_PAGINACION_CONTACTOS_LISTA,
        {
          limite: filters.limite,
          idGerencia: filters.idGerencia,
          nombre: filters.nombre,
        },
        true
      );

      if (tipo === "modal") {
        commit("setContactPaginationModal", pagination || []);
      } else {
        commit("setContactPagination", pagination || []);
      }

      if (pagination && pagination[0]) {
        await dispatch("getContactListPage", { tipo, pageData: pagination[0] });
      } else {
        if (tipo === "modal") {
          commit("setContactListsModal", []);
        } else {
          commit("setContactLists", []);
        }
      }

      return pagination;
    } catch (error) {
      console.error("Error obteniendo listas de contacto:", error);
      toastError("No fue posible cargar las listas de contacto.");
      const tipo = payload.tipo || "main";
      if (tipo === "modal") {
        commit("setContactListsModal", []);
        commit("setContactPaginationModal", []);
      } else {
        commit("setContactLists", []);
        commit("setContactPagination", []);
      }
      return [];
    }
  },

  async getContactListPage({ commit }, payload = {}) {
    try {
      const tipo = payload.tipo || "main";
      const pageData = payload.pageData || payload;
      const page = await exQue(
        GET_LIST_CONTACTOS_USUARIOS,
        { idUsuario: pageData.ids },
        true
      );
      const safePage = Array.isArray(page) ? page : [];
      if (tipo === "modal") {
        commit("setContactListsModal", safePage);
      } else {
        commit("setContactLists", safePage);
      }
      return safePage;
    } catch (error) {
      console.error("Error obteniendo página de contactos:", error);
      toastError("No fue posible cargar los contactos.");
      const tipo = payload.tipo || "main";
      if (tipo === "modal") {
        commit("setContactListsModal", []);
      } else {
        commit("setContactLists", []);
      }
      return [];
    }
  },

  async fetchDestinatariosListas({ commit }) {
    try {
      const listas = await exQue(LIST_LISTAS_CONTACTOS, {}, true);
      commit("setDestinatariosListas", listas || []);
    } catch (e) {
      console.error("Error obteniendo listas de destinatarios:", e);
      toastError("No fue posible cargar las listas de destinatarios.");
      commit("setDestinatariosListas", []);
      return [];
    }
  },

  async getGerencias({ commit, rootGetters }, id_empresa) {
    try {
      const gerencias = await exQue(
        GET_GERENCIAS,
        { id_empresa },
        false,
        "",
        `No fue posible cargar ${losPlural(rootGetters, "GERENCIA")}.`
      );
      commit("setGerencias", gerencias || []);
    } catch (error) {
      console.error("Error obteniendo gerencias:", error);
      commit("setGerencias", []);
    }
  },
  async getCargos({ commit, rootGetters }, id_empresa) {
    try {
      const cargos = await exQue(
        GET_CARGOS,
        { id_empresa },
        false,
        "",
        `No fue posible cargar ${losPlural(rootGetters, "CARGO")}.`
      );
      commit("setCargos", cargos || []);
    } catch (error) {
      console.error("Error obteniendo cargos:", error);
      commit("setCargos", []);
    }
  },
  async getSucursales({ commit, rootGetters }, id_empresa) {
    try {
      const sucursales = await exQue(
        GET_SUCURSALES,
        { id_empresa },
        false,
        "",
        `No fue posible cargar ${losPlural(rootGetters, "SUCURSAL")}.`
      );
      commit("setSucursales", sucursales || []);
    } catch (error) {
      console.error("Error obteniendo sucursales:", error);
      commit("setSucursales", []);
    }
  },
  async getTurnos({ commit, rootGetters }, id_empresa) {
    try {
      const turnos = await exQue(
        GET_WORK_SHIFTS,
        { id_empresa },
        false,
        "",
        `No fue posible cargar ${losPlural(rootGetters, "TURNO")}.`
      );
      commit("setTurnos", turnos || []);
    } catch (error) {
      console.error("Error obteniendo turnos:", error);
      commit("setTurnos", []);
    }
  },
  async getSindicatos({ commit, rootGetters }, id_empresa) {
    try {
      const sindicatos = await exQue(
        GET_SINDICATO,
        { id_empresa },
        false,
        "",
        `No fue posible cargar ${losPlural(rootGetters, "SINDICATO")}.`
      );
      commit("setSindicatos", sindicatos || []);
    } catch (error) {
      console.error("Error obteniendo sindicatos:", error);
      commit("setSindicatos", []);
    }
  },

  /**
   * Obtiene los contactos (por email) asociados a la empresa.
   * @returns {Promise<Array>} Listado de contactos
   */
  async getContacts({ commit }) {
    try {
      const contacts = await exQue(LIST_CONTACTOS_BY_EMAIL);
      const safeContacts = Array.isArray(contacts) ? contacts : [];
      commit("setContacts", safeContacts);
      return safeContacts;
    } catch (error) {
      console.error("Error obteniendo contactos:", error);
      toastError("No fue posible cargar los contactos.");
      commit("setContacts", []);
      return [];
    }
  },
  async createMailCategoria({ dispatch }, payload) {
    const response = await exMut(CREATE_MAIL_CATEGORIA, payload);
    dispatch("getCategorias");
    return response;
  },
  async updateMailCategoria({ commit, dispatch }, payload) {
    const response = await exMut(UPDATE_MAIL_CATEGORIA, payload);
    if (response) {
      commit("replaceCategorias", response);
      dispatch("getCategorias");
    }
    return response;
  },
  async deleteMailCategoria({ dispatch }, payload) {
    const response = await exMut(
      DELETE_MAIL_CATEGORIA,
      payload,
      "Categoría eliminada exitosamente.",
      "No fue posible eliminar la categoría."
    );
    if (response) await dispatch("getCategorias");
    return response;
  },

  /**
   * Crea o actualiza una lista de contactos.
   * Nota: para crear, usar `id_lista: 0`.
   */
  async createOrUpdateListaContactos({ dispatch }, payload = {}) {
    const variables = {
      nombre_lista: payload.nombre_lista || "",
      id_lista: Number(payload.id_lista || 0),
      id_cargo: Array.isArray(payload.id_cargo) ? payload.id_cargo.map(Number) : [],
      id_gerencia: Array.isArray(payload.id_gerencia) ? payload.id_gerencia.map(Number) : [],
      id_sucursal: Array.isArray(payload.id_sucursal) ? payload.id_sucursal.map(Number) : [],
      id_usuario: Array.isArray(payload.id_usuario) ? payload.id_usuario.map(Number) : [],
    };

    const res = await exMut(
      CREATE_MAIL_CONTACTOS_LISTA,
      variables,
      "Lista guardada exitosamente.",
      "No fue posible guardar la lista.",
      MUTACION_CON_CACHE
    );

    if (res) {
      await dispatch("fetchDestinatariosListas");
    }

    return res;
  },

  /**
   * Elimina una lista de contactos por id.
   */
  async deleteListaContactos({ dispatch }, idLista) {
    const id = Number(idLista);
    if (!id) return null;

    const res = await exMut(
      DELETE_MAIL_CONTACTOS_LISTA,
      { idLista: id },
      "Lista eliminada exitosamente.",
      "No fue posible eliminar la lista."
    );

    if (res) {
      await dispatch("fetchDestinatariosListas");
    }

    return res;
  },
  async deleteTemplate({ commit, dispatch }, payload) {
    const id = Number(payload?.id_template || payload);
    if (!id) return null;
    const res = await exMut(
      DELETE_TEMPLATE,
      { idTemplate: id },
      "Template eliminado exitosamente.",
      "No fue posible eliminar el template."
    );

    const idCategoria = Number(
      res?.id_categoria_fk || payload?.id_categoria_fk || payload?.categoria_fk
    );

    if (res && idCategoria) {
      commit("removeTemplateFromCategory", {
        idTemplate: id,
        idCategoria,
      });
    }

    if (res) {
      await dispatch("getCategorias");
    }
    return res;
  },

  async getCorreosAutomatizados({ commit }) {
    try {
      const items = await exQue(GET_LIST_CORREOS_AUTOMATIZADOS);
      commit("setCorreosAutomatizados", mapTemplatesToForm(items || []));
    } catch (error) {
      console.error("Error obteniendo correos automatizados:", error);
      toastError("No fue posible cargar las automatizaciones.");
      commit("setCorreosAutomatizados", []);
    }
  },

  async deleteCorreoAutomatizado({ commit }, template) {
    if (!template || !template.id_template) return;
    const id = Number(template.id_template);
    const res = await exMut(
      DELETE_TEMPLATE,
      { idTemplate: id },
      "Automatizacion eliminada exitosamente.",
      "No fue posible eliminar la automatizacion."
    );
    if (res) {
      commit("removeCorreoAutomatizado", id);
    }
    return res;
  },
};

export const recursosGetters = {};
